import { resolveDefaultDate } from "./dateDefaults";
import { pickerDateToDateValue } from "./dateTimezone";
import type { DateDefaultContext } from "./dateDefaults";
import type { DateFieldValue } from "./date.config";

export interface DateFieldDefaultContext extends DateDefaultContext {
  includeTime: boolean;
}

// A default is stored exactly as the picker stores a hand-picked day, so both flow through the
// display, picker and submit paths identically. A bare "YYYY-MM-DD" does not: every consumer
// reparses it as UTC midnight and renders it a day early west of GMT (BUG-21601).
export const normalizeDateDefaultValue = (
  value: string,
  { timezone, includeTime }: DateFieldDefaultContext
): DateFieldValue | undefined => {
  const date = resolveDefaultDate(value, timezone);
  if (!date) return undefined;

  return pickerDateToDateValue(date, includeTime, timezone);
};
